/*Package importing*/
import React, { Component } from 'react';

/*Components*/
import SelectBox from '../../components/formComponents/selectBox';
import NoDataFound from '../../components/other/nothing';
import APILoader from '../../components/other/api-loader';

/*Services*/
import devconfig from '../../config/config.js';
import APIPost from '../../services/apiCall/post';
import APIGet from '../../services/apiCall/get';
import GetURLVar from '../../services/getParams/get-url-var';


class ProductDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tabIndex: 1,
            color: "",
            size: "",
            id: 0,
            data: null,
            variant: 0,
            choice: 0,
            variantOptions: [],
            choiceOptions: [],
            choices: [],
            preview: 0,
            apiLoading: false
        }
    }

    componentDidMount() {
        GetURLVar().then(function (query) {
            if (query) {
                this.setState({ id: query.id })
                this.getData(query.id);
            }
        }.bind(this));
    }

    async getData(id) {
        this.setState({apiLoading: true, error: ""});
        let url = devconfig.vendor + 'product/detail';
        let data = JSON.stringify({
            "product_id": id
        });
        APIPost(url, data).then(function (response) {
            if (response.status == "ok") {
                this.setState({ data: response.data });
                this.setOptions(response.data);
                this.setState({apiLoading: false, error: ""});
            }
            else{
                this.setState({apiLoading: false, error: response.message});
            }
        }.bind(this))
    }

    setOptions(data) {
        let variants = [];
        let choices = [];
        data.variants.forEach((variant, i) => {
            const option = { value: i, label: variant.name }
            let choiceGroup = []
            variant.choices.forEach((item, j) => {
                const options = { value: j, label: item.name }
                choiceGroup.push(options);
            });
            variants.push(option);
            choices.push(choiceGroup);
        })
        this.setState({ variantOptions: variants, choices: choices });
        console.log(choices);
    }

    tabItemClick(tempItem) {
        this.setState({ tabIndex: tempItem });
    }
    colorChange = async (color) => {
        await this.setState({ color: color });
    }
    sizeChange = async (size) => {
        await this.setState({ size: size });
    }


    render() {
        const color = [
            { value: 1, label: 'Blue' },
            { value: 2, label: 'Black' },
        ]
        const size = [
            { value: 1, label: '32' },
            { value: 2, label: '36' },
        ]

        return (
            <div>
                <div className="e-main-content e-vendor-table">
                    <h2 className="e-page-head">View Products / Services</h2>
                    {
                        this.state.apiLoading?
                        <div className="row pt-5">
                            <div className="col-lg-12 pt-5">
                                <APILoader/>
                            </div>
                        </div>
                        :
                        <div className="row">
                        {
                            this.state.data ?
                                <div className="col-lg-12 pb-5">
                                    <div className="e-vendor-category-list e-edit-ad e-local-product-detail">
                                        <div className="e-product-detail">
                                            <div className="container pb-3">
                                                <div className="row">
                                                    <div className="col-lg-1 col-md-2 co-sm-2 col-4">
                                                        <div className="row">
                                                            {
                                                                this.state.data.images.map((image, i) => (
                                                                    <div className="col-lg-12">
                                                                        <img src={image} alt="i" className="e-thumbnail" onClick={() => this.setState({ preview: i })} />
                                                                    </div>
                                                                ))
                                                            }
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-5 col-md-10 col-sm-10 col-8 ">
                                                        <img src={this.state.data.images[this.state.preview]} alt="image" className="rounded" style={{ maxWidth: "100%" }} />
                                                    </div>
                                                    <div className="col-lg-6 col-md-6">
                                                        <div className="col-lg-12">
                                                            <h2 className="h2 font-weight-bold">{this.state.data.name}</h2>
                                                            <p className="pt-3 mb-0">Brand: <span className="h5 font-weight-bold">{this.state.data.brand}</span></p>
                                                            <p className="pt-4">Price: <span className="h5 font-weight-bold pl-2" style={{ opacity: "0.77" }}>{this.state.data.variants[this.state.variant].choices[this.state.choice]? `₹${this.state.data.variants[this.state.variant].choices[this.state.choice].selling_price}`: "--"}</span><span className="h5 pl-3 font-weight-light" style={{ opacity: "0.47" }}><strike>{this.state.data.variants[this.state.variant].choices[this.state.choice]? `₹${this.state.data.variants[this.state.variant].choices[this.state.choice].mrp}`: "--"}</strike></span></p>
                                                            <div className="row pt-5 pr-4">
                                                                <div className="col-lg-12">
                                                                    <div className="d-flex align-items-center justify-content-center">
                                                                        <p className="pt-3" style={{ minWidth: "56px" }}>Variant:</p>
                                                                        <div className="container"><SelectBox
                                                                            selectchange={async (item) => {
                                                                                let temp = this.state.choices;
                                                                                await this.setState({ variant: item.value, choiceOptions: temp[item.value] });
                                                                            }}
                                                                            options={this.state.variantOptions} placeholder="Variant" /></div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-12">
                                                                    <div className="d-flex align-items-center justify-content-center">
                                                                        <p className="pt-3" style={{ minWidth: "56px" }}>Choice:</p>
                                                                        <div className="container"><SelectBox
                                                                            selectchange={(item) => {
                                                                                this.setState({ choice: item.value })
                                                                            }} options={this.state.choiceOptions} placeholder="Choice" /></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12 col-10 pt-4">
                                                           {
                                                               this.state.data.button_text?
                                                               <button className="e-s-btn" >{this.state.data.button_text}</button>
                                                               :
                                                               null
                                                           }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="e-product-detail-tab my-3">
                                            <div className="container">
                                                <div className="row">
                                                    <div className="col-lg-12">

                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                {
                                                                    this.state.tabIndex === 1 ?
                                                                        <span className="e-tabs-item e-active">Overview</span>
                                                                        :
                                                                        <span onClick={this.tabItemClick.bind(this, 1)} className="e-color-inactive">Overview</span>
                                                                }

                                                                {
                                                                    this.state.tabIndex === 2 ?
                                                                        <span className="e-tabs-item e-active">Description</span>
                                                                        :
                                                                        <span onClick={this.tabItemClick.bind(this, 2)} className="e-color-inactive">Description</span>
                                                                }
                                                                {
                                                                    this.state.tabIndex === 3 ?
                                                                        <span className="e-tabs-item e-active">Return Policy</span>
                                                                        :
                                                                        <span onClick={this.tabItemClick.bind(this, 3)} className="e-color-inactive">Return Policy</span>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div className="row pt-3">
                                                            <div className="col-md-12">
                                                                <div className="e-border-bottom"></div>
                                                            </div>
                                                        </div>

                                                        {
                                                            this.state.tabIndex === 1 ?
                                                                <React.Fragment>
                                                                    <div className="row pb-5">
                                                                        <div className="col-lg-4 pt-3">
                                                                            <h5 className="e-tab-content-header">Overview</h5>
                                                                            <p className="e-tab-content-paragraph pt-3">{this.state.data.overview}</p>
                                                                        </div>
                                                                        <div className="col-lg-4 pt-3">
                                                                            <h5 className="e-tab-content-header">Instructions</h5>
                                                                            <ul className="e-tab-content-paragraph pt-3">
                                                                                {
                                                                                    this.state.data.instructions.map(instruction => (
                                                                                        <li>{instruction}</li>
                                                                                    ))
                                                                                }
                                                                            </ul>
                                                                        </div>
                                                                        <div className="col-lg-4 pt-3">
                                                                            <h5 className="e-tab-content-header">Other</h5>
                                                                            <ul className="e-tab-content-paragraph pt-3">
                                                                                {
                                                                                    this.state.data.other_things_1.map(item => (
                                                                                        <li>{item}</li>
                                                                                    ))
                                                                                }
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </React.Fragment>
                                                                :
                                                                null
                                                        }
                                                        {
                                                            this.state.tabIndex === 2 ?
                                                                <React.Fragment>
                                                                    <div className="row pb-5">
                                                                        <div className="col-lg-4 pt-3">
                                                                            <h5 className="e-tab-content-header">Highlights</h5>
                                                                            <ul className="e-tab-content-paragraph pt-3">
                                                                                {
                                                                                    this.state.data.highlights.map(item => (
                                                                                        <li>{item}</li>
                                                                                    ))
                                                                                }
                                                                            </ul>
                                                                            <p className="e-tab-content-paragraph">Made in Italy</p>
                                                                        </div>
                                                                        <div className="col-lg-4 pt-3">
                                                                            <h5 className="e-tab-content-header">Specifications</h5>
                                                                            <ul className="e-tab-content-paragraph pt-3">
                                                                                {
                                                                                    this.state.data.specifications.map(item => (
                                                                                        <li>{item}</li>
                                                                                    ))
                                                                                }
                                                                            </ul>
                                                                        </div>
                                                                        <div className="col-lg-4 pt-3">
                                                                            <h5 className="e-tab-content-header">Other</h5>
                                                                            <ul className="e-tab-content-paragraph pt-3">
                                                                                {
                                                                                    this.state.data.other_things_2.map(item => (
                                                                                        <li>{item}</li>
                                                                                    ))
                                                                                }
                                                                            </ul>
                                                                        </div>
                                                                    </div>
                                                                </React.Fragment>
                                                                :
                                                                null
                                                        }
                                                        {
                                                            this.state.tabIndex === 3 ?
                                                                <React.Fragment>
                                                                    <div className="row pb-5">
                                                                        <div className="col-lg-12 pt-3">
                                                                            <h5 className="e-tab-content-header">Policies</h5>
                                                                            <p className="e-tab-content-paragraph pt-3 mb-0">{this.state.data.return_policy}</p>
                                                                        </div>
                                                                        <div className="col-lg-12 pt-3">
                                                                            <h5 className="e-tab-content-header">Others</h5>
                                                                            <p className="e-tab-content-paragraph pt-3 mb-0">{this.state.data.other_things_3}</p>
                                                                        </div>

                                                                    </div>
                                                                </React.Fragment>
                                                                :
                                                                null
                                                        }

                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                :
                                <div className="col-lg-12 pt-5">
                                    <NoDataFound head="Nothing Found" data="No Product Details Found"/>
                                </div>
                        }
                    </div>
                    }
                </div>
            </div>
        );
    }
}

export default ProductDetail;
